import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import bindMethods from 'auto-bind';
import { withTheme } from 'styled-components';

import getProductById from '../../state/selectors/getProductById';
import ProductForm from '../../forms/ProductForm';
import FormHeadline from '../../components/form/FormHeadline';
import SSOButton from '../../components/SSOButton';
import { ButtonContainer, HeadlineContainer } from '../../components/form/FormStyles';

class EditProduct extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.submitForm = null;
  }

  bindSubmitForm(submitForm) {
    this.submitForm = submitForm;
  }

  handleCancelButtonClick() {
    const { history } = this.props;
    return history.goBack();
  }

  handleSubmitForm(event) {
    if (this.submitForm) {
      this.submitForm(event);
    }
  }

  render() {
    const { t, theme, product } = this.props;

    if (!product) {
      return null;
    }

    return (
      <div>
        <HeadlineContainer>
          <FormHeadline
            id="Product.Headline.GeneralInformation"
            headline={t('Pages.Products.Headlines.GeneralInformation')}
          />

          <ButtonContainer>
            <SSOButton
              id="Cancel"
              text={t('Shared.General.Cancel')}
              onClick={this.handleCancelButtonClick}
            />
            <SSOButton
              id="Submit"
              text={t('Shared.General.UpdateClose')}
              onClick={this.handleSubmitForm}
              backgroundColor={theme.PRIMARY}
            />
          </ButtonContainer>
        </HeadlineContainer>
        <ProductForm bindSubmitForm={this.bindSubmitForm} product={product} />
      </div>
    );
  }
}

EditProduct.propTypes = {
  history: PropTypes.object.isRequired, // supplied from React Router
  t: PropTypes.func.isRequired, // supplied from withTranslation
  theme: PropTypes.object.isRequired, // supplied from withTheme
  product: PropTypes.object.isRequired, // supplied from Redux
};

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps.match.params;
  return {
    product: getProductById(state, id),
  };
};

const TranslatedComponent = withTranslation()(EditProduct);
const ThemedComponent = withTheme(TranslatedComponent);
export default connect(mapStateToProps)(ThemedComponent);
